import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ShortResponseDto, UserAlertRulesAlertListDto, UserAlertRulesCompanyAlertRequestDto, UserAlertRulesListDto, UserAlertsRequestDto } from '../../dto';
import { BaseApiService } from './base-api.service';

@Injectable({
    providedIn: 'root',
})
export class NewsAutomationsUserAlertRulesApiService {
    private readonly url: string = 'service/contactcloud/newsAutomations/userAlertRules';

    constructor(private readonly baseApiService: BaseApiService) {
    }

    getUserAlertRulesList(params?: UserAlertsRequestDto): Observable<UserAlertRulesListDto> {
        return this.baseApiService.get<UserAlertRulesListDto>(`${this.url}/list`, {
            params: (params as HttpParams),
        });
    }

    getUserAlertRulesAlertList(companyId: string): Observable<UserAlertRulesAlertListDto> {
        return this.baseApiService.get<UserAlertRulesAlertListDto>(`${this.url}/alertList`, {
            params: { companyId },
        });
    }

    saveUserAlertRules(body: UserAlertRulesCompanyAlertRequestDto): Observable<ShortResponseDto<string>> {
        return this.baseApiService.post<ShortResponseDto<string>>(`${this.url}/save`, body);
    }

    deleteUserAlertRules(body: UserAlertRulesCompanyAlertRequestDto): Observable<ShortResponseDto<string>> {
        return this.baseApiService.post<ShortResponseDto<string>>(`${this.url}/delete`, body);
    }
}
